import React, { Component } from 'react';

import { ContentSection, ContentBlock } from '../components';
import ProductListContainer from '../../product/components/ProductListContainer';
import {Localize} from '../../../locale/localization';

class ProductAdminPage extends Component {
  render() {
    return (
      <ContentSection>
        <ContentBlock title={Localize("packages")}>
          <ProductListContainer />
        </ContentBlock>
      </ContentSection>
    );
  }
};

export default ProductAdminPage;


// WEBPACK FOOTER //
// ./src/modules/pages/admin/ProductAdminPage.js